import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import ReactSuperSelect from 'react-super-select';
import requiredIf from 'react-required-if';
import SelectComponent from './SelectComponent';
import ConditionalComponent from './ConditionalComponent';
import {
  FormGroup,
  Col,
  Row,
  ControlLabel,
  FormControl,
  Checkbox,
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Moment from 'moment';
import {
  PERFORMANCE_METRICS_TOGGLES, pageTypes as constants,
  componentHelper
} from './../helpers';

export default class RegressionTestsPerformanceSelectorComponent extends React.Component {
  static propTypes = {
    metricsByDateInfo: PropTypes.shape({
      timestamp: PropTypes.number.isRequired,
      runCount: PropTypes.number.isRequired
    }).isRequired,
    metricsInfo: PropTypes.shape({
      toggles: PropTypes.number.isRequired,
      buildFilter: PropTypes.string.isRequired,
      exportType: requiredIf(PropTypes.string, props =>
        props.pageType === constants.EXPORTTESTS),
      exportConfig: requiredIf(PropTypes.string, props =>
        props.pageType === constants.EXPORTTESTS),
      exportCase: requiredIf(PropTypes.string, props =>
        props.pageType === constants.EXPORTTESTS),
      dispatcherId: PropTypes.number.isRequired,
      jobName: PropTypes.string,
      snPartI: PropTypes.string,
      snPartII: PropTypes.string,
      snPartIII: PropTypes.string
    }).isRequired,
    availableSNsPartI: PropTypes.array.isRequired,
    availableSNsPartIIByPartI: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    availableSNsPartIIIByPartINII: PropTypes.object.isRequired,
    availableDispatchers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      number: PropTypes.number.isRequired,
      scenarioCount: PropTypes.number.isRequired
    })),
    onSelectorChange: PropTypes.func.isRequired,
    pageType: PropTypes.object.isRequired
  }

  // pulls out the Local's forms dispatcher for use
  attachDispatch = (dispatch) => this.formDispatch = dispatch;

  getSNsPartI = () => this.props.availableSNsPartI;

  getSNsPartIIbyPartI = (type) =>
  {
    if (type && this.props.availableSNsPartIIByPartI)
    {
      return this.props.availableSNsPartIIByPartI[type] ?
        Array.from(this.props.availableSNsPartIIByPartI[type]) : [];
    }
    return [];
  }

  getSNsPartIIIbyPartINII = (type, config) => {
    if (type && config && this.props.availableSNsPartIIIByPartINII)
    {
      return this.props.availableSNsPartIIIByPartINII[type + config] ?
        Array.from(this.props.availableSNsPartIIIByPartINII[type + config]) : [];
    }
    return [];
  }

  getScenarioNames = () => this.props.availableSNsPartIIByPartI;

  getInitialDispatcherOption = (id) => {
    const dispatcher = this.props.availableDispatchers.find(d => d.id === id);
    const text = 'Scenarios';

    return {
      id,
      number: dispatcher ? dispatcher.number : 0,
      name: dispatcher ?
        `${dispatcher.number} - (${text}:${dispatcher.scenarioCount})` :
        id === 0 ? 'Select a Dispatcher...' : 'Loading Dispatchers',
      jobId: dispatcher ? dispatcher.jobId : 0
    };
  }

  getDispatcherOptions = () => this.props.availableDispatchers.map(
    d => {
      const text = 'Scenarios';

      return {
        id: d.id,
        number: d.number,
        jobId: d.jobId,
        name: `${d.number} - (${text}:${d.scenarioCount}) ${d.name}`
      };
    }
  );

  render() {
    const {
      metricsByDateInfo,
      metricsInfo,
      onSelectorChange,
      pageType
    } = this.props;

    const initialState =
      {
        timestamp: metricsByDateInfo.timestamp,
        runCount: metricsByDateInfo.runCount,
        toggles: metricsInfo.toggles,
        buildFilter: metricsInfo.buildFilter,
        snPartI: metricsInfo.snPartI ? metricsInfo.snPartI : '',
        snPartII: metricsInfo.snPartII ? metricsInfo.snPartII : '',
        snPartIII: metricsInfo.snPartIII ? metricsInfo.snPartIII : '',
        dispatcherId: metricsInfo.dispatcherId,
        jobName: metricsInfo.jobName
      }
    ;

    return (
      <div>
        <fieldset>
          <legend> Filters </legend>
          <LocalForm
            id="metrics-selector-form"
            getDispatch={dispatch => this.attachDispatch(dispatch)}
            model="info"
            initialState={initialState}
            onChange={model => onSelectorChange(model)}
          >
            <FormGroup>
              <Row>
                <Col md={3}>
                  <ControlLabel> Regression Run Since </ControlLabel>
                  <Control.custom
                    id="datepicker-input"
                    model=".timestamp"
                    component={DatePicker}
                    className="form-control"
                    mapProps={({ modelValue, onChange }) => {
                      return {
                        dateFormat: 'MMM Do, YYYY',
                        selected: Moment.unix(modelValue),
                        onChange: date => onChange(date.unix(date)),
                        maxDate: Moment()
                      };
                    }}
                    fixedHeight
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={10}
                    shouldCloseOnSelect={false}
                  />
                </Col>
                <Col md={2}>
                  <ControlLabel> Runs to Show </ControlLabel>
                  <Control
                    id="run-count-input"
                    model=".runCount"
                    className="form-control"
                    component={FormControl}
                    type="number"
                  />
                </Col>
                <Col md={1}>
                  <ControlLabel> Include </ControlLabel>
                  <div>
                    <Control.custom
                      id="outlier-type-check"
                      component={Checkbox}
                      model=".toggles"
                      mapProps={({ modelValue, onChange }) => {
                        const value = PERFORMANCE_METRICS_TOGGLES.OUTLIER;
                        return {
                          onChange: c =>
                            onChange(componentHelper.getTogglesValue(
                              modelValue,
                              value,
                              c.target.checked
                            )),
                          checked: componentHelper.getChecked(modelValue, value)
                        };
                      }}
                      inline
                    >
                      Outliers
                    </Control.custom>
                  </div>
                </Col>
                <Col md={2}>
                  <ControlLabel> Run Number </ControlLabel>
                  <Control.custom
                    id="build-input"
                    model="."
                    className="form-control"
                    component={FormControl}
                    type="text"
                    mapProps={({ modelValue, onChange }) => {
                      return {
                        value: modelValue.buildFilter,
                        onChange: i => {
                          const model = {
                            ...modelValue,
                            buildFilter: i.target.value
                          };
                          onChange(model);
                        }
                      };
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <ControlLabel> Dispatcher </ControlLabel>
                  <Control.custom
                    id="dispatcher-select"
                    model="."
                    component={ReactSuperSelect}
                    className="form-control"
                    style={{ marginRight: '10px' }}
                    mapProps={({ modelValue, onChange }) => {
                      return {
                        initialValue:
                      this.getInitialDispatcherOption(
                        modelValue.dispatcherId, pageType),
                        noneOption: 'Select a Dispatcher...',
                        dataSource: this.getDispatcherOptions(pageType),
                        onChange: option => {
                          const filter = option && option.number !== 0 ?
                            `d:${option.number}` :
                            '';
                          const model = {
                            ...modelValue,
                            buildFilter: filter,
                            dispatcherId: option ? option.id : modelValue.dispatcherId
                          };
                          return onChange(model);
                        },
                        onClear: () => {
                          const model = {
                            ...modelValue,
                            buildFilter: '',
                            dispatcherId: 0
                          };
                          return onChange(model);
                        }
                      };
                    }}
                    searchable
                  />
                </Col>
              </Row>
              <Row>
                <ConditionalComponent
                  condition={pageType !== constants.CASEAMENDINGKPPTESTS}
                >
                  <Col md={2}>
                    { pageType === constants.EXPORTTESTS &&
                (<ControlLabel> Export Type </ControlLabel>) ||
                (pageType === constants.JOBBENCHMARK &&
                  <ControlLabel> Benchmark Type </ControlLabel> ||
                  (<ControlLabel> Job Type </ControlLabel>))}
                    <Control.custom
                      id="case-select"
                      model="."
                      component={SelectComponent}
                      className="form-control"
                      style={{ marginRight: '10px' }}
                      mapProps={({ modelValue, onChange }) => {
                        return {
                          noneOption: 'Select a Type...',
                          options: this.getSNsPartI(),
                          selected: modelValue.snPartI,
                          onChange: d => {
                            const model = {
                              ...modelValue,
                              snPartI: d,
                              snPartII: '',
                              snPartIII: ''
                            };
                            onChange(model);
                          }
                        };
                      }}
                    />
                  </Col>
                </ConditionalComponent>
                <Col md={4}>
                  { pageType === constants.EXPORTTESTS &&
              (<ControlLabel> Configure </ControlLabel>) ||
              (<ControlLabel> Case </ControlLabel>)}
                  <Control.custom
                    id="action-select"
                    model="."
                    component={SelectComponent}
                    className="form-control"
                    style={{ marginRight: '10px' }}
                    mapProps={({ modelValue, onChange }) => {
                      return {
                        noneOption: pageType === constants.EXPORTTESTS ?
                          'Select a Config...' : 'Select a Case...',
                        options: pageType === constants.CASEAMENDINGKPPTESTS ?
                          this.getScenarioNames() :
                          this.getSNsPartIIbyPartI(modelValue.snPartI),
                        selected: modelValue.snPartII,
                        onChange: d => {
                          const model = {
                            ...modelValue,
                            snPartII: d,
                            snPartIII: ''
                          };
                          onChange(model);
                        }
                      };
                    }}
                  />
                </Col>
                <ConditionalComponent condition={pageType === constants.EXPORTTESTS}>
                  <Col md={5}>
                    <ControlLabel> Case </ControlLabel>
                    <Control.custom
                      id="action-select"
                      model="."
                      component={SelectComponent}
                      className="form-control"
                      style={{ marginRight: '10px' }}
                      mapProps={({ modelValue, onChange }) => {
                        return {
                          noneOption: 'Select a Case...',
                          options: this.getSNsPartIIIbyPartINII(
                            modelValue.snPartI, modelValue.snPartII),
                          selected: modelValue.snPartIII,
                          onChange: d => {
                            const model = {
                              ...modelValue,
                              snPartIII: d
                            };
                            onChange(model);
                          }
                        };
                      }}
                    />
                  </Col>
                </ConditionalComponent>
              </Row>
            </FormGroup>
          </LocalForm>
        </fieldset>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/RegressionTestsPerformanceSelectorComponent.jsx